import React, { ChangeEvent } from "react";
import {
  FormControl,
  FormHelperText,
  Grid,
  OutlinedInput,
  Typography,
} from "@mui/material";
import { ICredentialsSouthpostProps } from "../../interfaces/configuration";

const CredentialsSouthpost = ({
  values,
  setValues,
  errors,
}: ICredentialsSouthpostProps) => {
  const showInputErrors = (inputErrors: string[]) =>
    inputErrors.map((message: string) => (
      <FormHelperText className="color-error" key={message}>
        {message}
      </FormHelperText>
    ));
  return (
    <Grid container spacing={3}>
      <Grid item xs={6}>
        <FormControl size="small" fullWidth>
          <Typography className="f-s-14 m-b-10">Código de sucursal</Typography>
          <OutlinedInput
            placeholder={"Ingresar código de sucursal"}
            value={values.branch_code}
            error={errors.branch_code?.length > 0}
            onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) =>
              setValues({ ...values, branch_code: value.trim() })
            }
            className="f-s-14"
            autoFocus
          />
          {errors.branch_code?.length > 0 &&
            showInputErrors(errors.branch_code)}
        </FormControl>
      </Grid>
      <Grid item xs={6}>
        <FormControl size="small" fullWidth>
          <Typography className="f-s-14 m-b-10">Token de contrato</Typography>
          <OutlinedInput
            placeholder={"Ingresar token de contrato"}
            value={values.api_token}
            error={errors.api_token?.length > 0}
            onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) =>
              setValues({ ...values, api_token: value.trim() })
            }
            className="f-s-14"
          />
          {errors.api_token?.length > 0 && showInputErrors(errors.api_token)}
        </FormControl>
      </Grid>
      {/* NOTE AGREGAR SELECT O CHECKBOXES PARA SERVICIOS VALIDOS O HARDCODEAR EN DB */}
    </Grid>
  );
};

export default CredentialsSouthpost;
